import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Form, Typography } from 'antd';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks';

import { InputStr, SubmiteButton } from 'shared/FormItems';

import { SmsService, useGetSmsServiceQuery, useUpdateSmsServiceMutation } from 'features/config';

type FormData = SmsService;

export const SMSService = () => {
  const [form] = Form.useForm<FormData>();
  const { data, isLoading } = useGetSmsServiceQuery();
  const [update, { isSuccess, isError, isLoading: isUpdateLoading, error }] = useUpdateSmsServiceMutation();

  const onFinish = (values: FormData) => {
    update(values);
  };

  useNotification({
    isSuccess,
    isError,
    error
  });

  if (isLoading) {
    return <LoadingOutlined />;
  }

  return (
    <div>
      <Flex align="center" justify="space-between">
        <Typography.Title level={2}>{t('pages.sms-service')}</Typography.Title>
      </Flex>

      <Form
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        name="basic"
        initialValues={data}
        style={{ maxWidth: '600px' }}
      >
        <InputStr type='apiKey' />
        <InputStr type='apiUrl' />
        <SubmiteButton isLoading={isUpdateLoading} />
      </Form>
    </div >
  );
};

